<div class="tab-wrapper">
    <div *ngFor="let tab of Items" class="tab-item" 
    [class.selected]="SelectedTab && SelectedTab.key === tab.key"
    (click)="SetSelectedTab(tab)">
        <span class="regular-svg" [inlineSVG]="tab.icon"></span>
        <span class="tab-item-label">{{ tab.label }}</span>
    </div>
</div>